import { Component } from '@angular/core';

@Component({
  template: '<h1 class="d-flex align-items-center justify-content-center min-vh-100">404</h1>',
})
export class NotFoundComponent {
  constructor() {}
}
